// extracted by mini-css-extract-plugin
export var bottom = "mobile-module--bottom--CSQCY";
export var dark_bottom = "mobile-module--dark_bottom--M63iQ";
export var dark_middle = "mobile-module--dark_middle--CxCeD";
export var dark_top = "mobile-module--dark_top--U2N8t";
export var light_bottom = "mobile-module--light_bottom--nlnl+";
export var light_middle = "mobile-module--light_middle--8gVX0";
export var light_top = "mobile-module--light_top--uB2D8";
export var middle = "mobile-module--middle--xcoU2";
export var top = "mobile-module--top--sKjxG";